module.exports = __webpack_public_path__ + "static/media/print_hsl_slices-min.7e87f0a7.gif";